'use client'

/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react'
import { Button } from '@components/common/AutoWidgetButton/button'
import { arrowSVG, checkedSVG, darkUnCheckedSVG, lightUncheckedSVG } from 'src/businessLandingPageMock'
import BusinessModals from '@components/BusinessModal/businessModals'
import { CONSTANTS_DATA } from '@constants/businessPages'
import Image from 'next/image'
import { ACKO_LOGO_HORIZONTAL_GRADIENT_DARK } from '@components/utils/ackoLogoUrls'
import Cookies from 'js-cookie'
import { callWebviewHandlerV2, WebViewActions } from '@utils/webview'
import { sendEnterpriseEvent } from '@utils/enterpriseSegmentEvent'
import { EVENT_TYPE, TAP_EVENT, VIEW_LEAD_GEN_POPUP } from '@constants/enterpriseSegmentData'
import styles from './businessHeader.module.scss'

const BusinessHeader = ({ data }) => {
  const desktopLogoData = data?.data?.attributes?.logo
  const mobileLogoData = data?.data?.attributes?.mobileLogo
  const categoriesData = data?.data?.attributes?.category
  const formSnippet = data?.data?.attributes?.formSnippet
  const stickyHeader = data?.data?.attributes?.stickyHeader

  const [isChecked, setIsChecked] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const dropdownRef = useRef(null)

  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (isModalOpen) {
      sendEnterpriseEvent({ view_name: VIEW_LEAD_GEN_POPUP }, EVENT_TYPE.VIEW)
    }
  }, [isModalOpen])

  const reDirectWithUrl = (url, tab = '_blank') => {
    url && window.open(url, tab)
  }

  const renderSubFeatures = subCategory =>
    subCategory?.map((subCategory, index) => (
      <div
        key={`${subCategory?.heading}-${index}`}
        className={styles.dropDownItem}
        onClick={() =>
          sendEnterpriseEvent({ action_name: subCategory?.heading, action_type: TAP_EVENT.TAP_NAV_BAR_OPTIONS }).then(
            () => reDirectWithUrl(subCategory?.url, '_self')
          )
        }>
        <div className={styles.logo}>
          <Image
            src={subCategory?.icon?.data?.attributes?.url}
            alt={`Subcategory-icon-${index}`}
            width={subCategory?.icon?.data?.attributes?.width}
            height={subCategory?.icon?.data?.attributes?.height}
            loading="lazy"
          />
        </div>
        <div className={styles.info}>
          <div className={styles.infoHeading}>{subCategory?.heading}</div>
          <div className={styles.infoSubHeading}>{subCategory?.subHeading}</div>
        </div>
      </div>
    ))

  const renderFeatures = () =>
    categoriesData?.map((feature, index) => {
      const isDropDown = feature?.subCategory.length !== 1
      const firstUrl = !isDropDown ? feature?.subCategory?.[0]?.url : undefined
      return (
        <div
          key={`${feature?.heading}-${index}`}
          className={styles.eachFeature}
          onClick={() =>
            sendEnterpriseEvent({ action_name: feature?.heading, action_type: TAP_EVENT.TAP_NAV_BAR_OPTIONS }).then(
              () => reDirectWithUrl(firstUrl)
            )
          }>
          <div className={`${styles.featureHeading} ${stickyHeader || scrolled ? styles.scrolledStyle : ''}`}>
            {feature?.heading}
          </div>
          {isDropDown && (
            <div ref={dropdownRef} className={styles.dropdown}>
              {renderSubFeatures(feature?.subCategory)}
            </div>
          )}
        </div>
      )
    })

  const renderSubFeaturesMweb = subCategory =>
    subCategory?.map((subCategory, index) => (
      <div
        key={`${subCategory?.heading}-${index}`}
        className={styles.dropDownItemm}
        onClick={() =>
          sendEnterpriseEvent({ action_name: subCategory?.heading, action_type: TAP_EVENT.TAP_NAV_BAR_OPTIONS }).then(
            () => reDirectWithUrl(subCategory?.url, '_self')
          )
        }>
        <div className={styles.logom}>
          <Image
            src={subCategory?.icon?.data?.attributes?.url}
            alt={`Subcategory-icon-${index}`}
            width={subCategory?.icon?.data?.attributes?.width}
            height={subCategory?.icon?.data?.attributes?.height}
            loading="lazy"
          />
        </div>
        <div className={styles.infom}>
          <div className={styles.infoHeadingm}>{subCategory?.heading}</div>
          <div className={styles.infoSubHeadingm}>{subCategory?.subHeading}</div>
        </div>
        <div className={styles.arrow}>{arrowSVG}</div>
      </div>
    ))

  const renderFeaturesMWeb = () =>
    categoriesData?.map((feature, index) => (
      <div key={`${feature?.heading}-${index}`} className={styles.eachFeaturem}>
        <div className={styles.featureHeadingm}>{feature?.heading}</div>
        <div className={styles.dropdownm}>{renderSubFeaturesMweb(feature?.subCategory)}</div>
      </div>
    ))

  const handleLogoClick = () => {
    if (Cookies.get('webview')) {
      callWebviewHandlerV2({
        url: '',
        action: WebViewActions.CLOSE_WEBVIEW,
      })
    } else window.open(data?.data?.attributes?.logoUrl, '_self')
  }

  useEffect(() => {
    isChecked
      ? (document.documentElement.style.overflowY = 'hidden')
      : (document.documentElement.style.overflowY = 'scroll')
  }, [isChecked])

  return (
    <div
      className={`${styles.main} ${isChecked && styles.fixed} ${(stickyHeader || scrolled) && styles.navbarBackground}`}
      id={CONSTANTS_DATA?.footerShowAt}>
      <div className={styles.header}>
        <div className={styles.ackoBusinessLogo}>
          <div onClick={handleLogoClick}>
            <div className={styles.desktopLogo}>
              <Image
                src={
                  stickyHeader || scrolled ? ACKO_LOGO_HORIZONTAL_GRADIENT_DARK : desktopLogoData?.data?.attributes?.url
                }
                alt="Header logo"
                width={desktopLogoData?.data?.attributes?.width}
                height={desktopLogoData?.data?.attributes?.height}
                priority
              />
            </div>
            <div className={styles.mobileLogo}>
              <Image
                src={
                  stickyHeader || scrolled ? ACKO_LOGO_HORIZONTAL_GRADIENT_DARK : mobileLogoData?.data?.attributes?.url
                }
                alt="Header logo mobile"
                width={mobileLogoData?.data?.attributes?.width}
                height={mobileLogoData?.data?.attributes?.height}
                style={{ cursor: 'pointer' }}
                priority
              />
            </div>
          </div>
        </div>
        <div className={styles.features}>{renderFeatures()}</div>
        {data?.data?.attributes?.buttonText && (stickyHeader || scrolled) && (
          <div className={styles.getInTouchButton}>
            <Button
              onClick={() => {
                sendEnterpriseEvent({
                  action_name: data?.data?.attributes?.buttonText,
                  action_type: TAP_EVENT.TAP_LEAD_GEN_POPUP,
                  view_name: VIEW_LEAD_GEN_POPUP,
                })
                setIsModalOpen(true)
              }}
              ctaText={data?.data?.attributes?.buttonText}
            />
            <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />
          </div>
        )}
        <div className={styles.icon} onClick={() => setIsChecked(!isChecked)}>
          {isChecked ? checkedSVG : stickyHeader || scrolled ? darkUnCheckedSVG : lightUncheckedSVG}
        </div>
      </div>
      {isChecked && (
        <>
          <div className={styles.featuresm}>{renderFeaturesMWeb()}</div>
          <div className={styles.bottom}>
            <div className={styles.getInTouchButton}>
              <Button
                onClick={() => {
                  sendEnterpriseEvent({
                    action_name: data?.data?.attributes?.buttonText,
                    action_type: TAP_EVENT.TAP_LEAD_GEN_POPUP,
                    view_name: VIEW_LEAD_GEN_POPUP,
                  })
                  setIsModalOpen(true)
                }}
                ctaText={data?.data?.attributes?.buttonText}
              />
              <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default BusinessHeader
